/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeaderRating } from '../models/LeaderRating';
import type { PaginatedLeaderRatingList } from '../models/PaginatedLeaderRatingList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeaderRatingsService {

    /**
     * @returns PaginatedLeaderRatingList
     * @throws ApiError
     */
    public static leaderRatingsList({
        limit,
        offset,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedLeaderRatingList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/leader-ratings/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns LeaderRating
     * @throws ApiError
     */
    public static leaderRatingsCreate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: LeaderRating,
    }): CancelablePromise<LeaderRating> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/leader-ratings/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
